export const GET_REGISTRATION_ERROR_QUERY_KEY = 'GET_REGISTRATION_ERROR_QUERY_KEY';
